/* Loofys: verzendkosten zakelijke geschenken als regels in de winkelwagen.
   - Doosjes van "Cadeaudoosje zakelijk" met eigenschap "Bezorgadres": 1x "Per adres" per uniek adres.
   - Doosjes zonder Bezorgadres: "Alles naar één adres", 1x per 200 doosjes.
   - Het zakelijke doosje zit in een verzendprofiel van € 0, zodat de checkout niet nog eens rekent.
   Draait op elke pagina en rekent opnieuw na elke wijziging van de winkelwagen. */
(function () {
  var C = window.LOOFYS_VERZEND;
  if (!C || !C.doosje || !C.adres || !C.bulk || !window.fetch) return;

  var origFetch = window.fetch.bind(window);
  var lopend = null;

  function sleutel(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }

  function bereken(cart) {
    var adressen = {}, bulk = 0, huidigA = 0, huidigB = 0;
    (cart.items || []).forEach(function (it) {
      if (it.product_id === C.doosje) {
        var a = it.properties && it.properties.Bezorgadres;
        if (a) adressen[sleutel(a)] = 1; else bulk += it.quantity;
      }
      if (it.variant_id === C.adres) huidigA += it.quantity;
      if (it.variant_id === C.bulk) huidigB += it.quantity;
    });
    return {
      nA: Object.keys(adressen).length,
      nB: bulk ? Math.ceil(bulk / (C.bulkMax || 200)) : 0,
      huidigA: huidigA,
      huidigB: huidigB
    };
  }

  /* Geeft true terug als de verzendregels zijn aangepast. */
  function sync() {
    if (lopend) return lopend;
    lopend = origFetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var b = bereken(cart);
        if (b.nA === b.huidigA && b.nB === b.huidigB) return false;
        var u = {};
        u[C.adres] = b.nA;
        u[C.bulk] = b.nB;
        return origFetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: u })
        }).then(function (r) { return r.ok; });
      })
      .catch(function () { return false; })
      .then(function (v) { lopend = null; return v; });
    return lopend;
  }

  function opCartPagina() { return location.pathname.replace(/\/$/, '') === '/cart'; }

  function naWijziging() {
    sync().then(function (veranderd) {
      if (!veranderd) return;
      if (opCartPagina()) { location.reload(); return; }
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    });
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch(input, init);
    if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
      p.then(function () { setTimeout(naWijziging, 50); }, function () {});
    }
    return p;
  };

  window.LoofysVerzending = { sync: sync };

  /* Bij het laden alleen nakijken als de winkelwagen een zakelijk doosje of een verzendregel bevat. */
  if (C.check) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', naWijziging);
    else naWijziging();
  }
})();
